import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last Updated: April 11, 2026
        </Typography>
        
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          1. Data Collection
        </Typography>
        <Typography variant="body1" paragraph>
          We collect personal information including your name, email, phone number, and Aadhar number for identification and security purposes.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          2. Data Usage
        </Typography>
        <Typography variant="body1" paragraph>
          Your data is used to manage room bookings, process payments via PhonePe, and maintain security logs (entry/exit). We do not sell your data to third parties.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          3. Security
        </Typography>
        <Typography variant="body1" paragraph>
          We use industry-standard encryption and secure Cloudflare infrastructure to protect your personal information and financial records.
        </Typography>

        <Divider sx={{ my: 4 }} />
        <Typography variant="body2" color="text.secondary" align="center">
          For privacy concerns, contact support@hostly-inn.com
        </Typography>
      </Paper>
    </Container>
  );
};

export default Privacy;
